<template>
  <div>
    <data-table ref="dataTable" :option="option">
      <template slot="headAction">
        <a-button
          style="margin-left:10px"
          type="primary"
          @click="qermission('1')"
          >菜单权限</a-button
        >
        <a-button
          style="margin-left:10px"
          type="primary"
          @click="roleQermission"
          >功能权限</a-button
        >
        <a-button
          style="margin-left:10px"
          type="primary"
          @click="roleReportQermission"
          >报表权限</a-button
        >
        <a-button
          style="margin-left:10px"
          type="primary"
          @click="companyRoleQermission"
          >门店角色权限</a-button
        >
      </template>
    </data-table>
    <checkbox-tree
      :title="title"
      :visible="visible.qermissionModal"
      :option="qermissionOption"
      :type="treeType"
      @submit="onSubmit"
      @close="onClose"
    />
    <a-modal
      centered
      :maskClosable="visible.maskClosable"
      title="报表权限"
      v-model="visible.roleReportQermissionModal"
      width="60%"
      @ok="handleOk"
    >
      <div style="height: calc(100vh - 250px)">
        <a-layout id="components-layout-demo-side" style="height: 100%">
          <a-layout-sider>
            <a-tree
              style="overflow:auto;height:100%"
              :treeData="treeData"
              @select="onSelect"
              :selectedKeys.sync="selectedKeys"
            ></a-tree>
          </a-layout-sider>
          <a-layout>
            <div>
              <div style="padding:8px;background: white;">
                <a-button
                  style="margin-left:5px"
                  type="primary"
                  @click="selectAll(true)"
                  >全选</a-button
                >
                <a-button
                  style="margin-left:10px"
                  type="primary"
                  @click="selectAll(false)"
                  >取消全选</a-button
                >
              </div>
              <data-grid
                :columns="columns"
                v-model="dataShow"
                rowKey="DataId"
                bordered
              />
              <!-- {{data}} -->
            </div>
          </a-layout>
        </a-layout>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import { DataGrid } from "@/components/dataGrid";
import CheckboxTree from "@/components/dataTree/CheckboxTree";
import { RoleQermissionModal, CompanyRoleQermissionModal } from "./funtion.js";

export default {
  name: "userManage_role",
  components: { DataTable, DataGrid, CheckboxTree },
  props: {},
  data() {
    return {
      visible: {
        maskClosable: false,
        qermissionModal: false,
        roleQermissionModal: false,
        roleReportQermissionModal: false
      },
      qermissionOption: {
        id: "",
        api: "",
        valueField: "Code",
        textField: "Name",
        children: "Childs",
        parentNode: false
      },
      title: "",
      treeType: "",
      selectedKeys: [],
      columns: [
        {
          title: "名称",
          dataIndex: "Name",
          width: "200px"
        },
        {
          title: "浏览",
          dataIndex: "CanPreview",
          width: "100px",
          edit: {
            type: "checkbox"
          }
        },
        {
          title: "打印",
          dataIndex: "CanPrint",
          width: "100px",
          edit: {
            type: "checkbox"
          }
        },
        {
          title: "导出",
          dataIndex: "CanExport",
          width: "100px",
          edit: {
            type: "checkbox"
          }
        },
        {
          title: "移动端",
          dataIndex: "CanMobile",
          width: "100px",
          edit: {
            type: "checkbox"
          }
        }
      ],
      data: [],
      dataShow: [],
      treeData: [] //角色报表权限左侧树
    };
  },
  created() {
    this.option = {
      headSearch: {
        colnum: 1,
        content: [
          {
            label: "角色名称",
            name: "Keyword"
          }
        ]
      },
      form: {
        colnum: 1,
        width: 500,
        title: "角色",
        add: {
          submitApi: "GroupRole_Add",
          onOpenAfter: () => {
            const form = this.$refs.dataTable.getForm();
            form.setFieldData("DefaultMenuId", []);
            return { ValidStatus: 1, DefaultMenuId: null };
          }
        },
        edit: {
          infoApi: "GroupRole_Get",
          submitApi: "GroupRole_Edit",
          onOpenAfter: value => {
            this.$post("GroupCommon_GetRoleMenusAsync", {
              Id: value.Data.Id
            }).then(res => {
              const form = this.$refs.dataTable.getForm();
              if (res.Data && res.Data.length > 0) {
                form.setFieldData("DefaultMenuId", res.Data);
                form.updateData();
              } else {
                form.setFieldData("DefaultMenuId", []);
              }
            });
            if (value.Data.DefaultMenuId == "0") {
              value.Data.DefaultMenuId = null;
              return value.Data;
            }
          }
        },
        del: { submitApi: "GroupRole_Del" },
        content: [
          {
            label: "编码",
            name: "Code",
            option: {
              rules: [{ required: true, message: "请填写编码！" }]
            }
          },
          {
            label: "名称",
            name: "Name",
            option: {
              rules: [{ required: true, message: "请填写名称！" }]
            }
          },
          {
            label: "默认菜单",
            name: "DefaultMenuId",
            type: "select"
            // api: "GetGroupSelectItems",
            // param: { types: "menu" },
            // dataField: "Data.menu"
          },
          {
            label: "描述",
            name: "Description"
          },
          {
            label: "状态",
            name: "ValidStatus",
            option: {
              rules: [{ required: true, message: "请选择状态！" }]
            },
            placeholder: "请选择",
            type: "select",
            valueField: "value",
            textField: "text",
            data: [
              {
                value: 0,
                text: "不启用"
              },
              {
                value: 1,
                text: "启用"
              }
            ]
          }
        ]
      },
      grid: {
        api: "GroupRole_List",
        columns: [
          {
            title: "序号",
            width: "60px",
            align: "center",
            type: "indexcolumn"
          },
          {
            title: "编码",
            width: 150,
            dataIndex: "Code"
          },
          {
            title: "名称",
            width: 200,
            dataIndex: "Name"
          },
          {
            title: "默认菜单",
            width: 150,
            dataIndex: "DefaultMenu"
          },
          {
            title: "描述",
            width: 300,
            dataIndex: "Description"
          },
          {
            title: "状态",
            width: 100,
            dataIndex: "ValidStatus",
            customRender: text => {
              if (text) {
                return <a-badge status="success" text="启用" />;
              } else {
                return <a-badge status="error" text="不启用" />;
              }
            }
          },
          {
            title: "操作",
            dataIndex: "Id",
            key: "action",
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
  },
  mounted() {},
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {
    //选择的树节点
    onSelect(selectedKeys) {
      this.dataShow = [];
      if (selectedKeys == "0") this.dataShow = this.data;
      else {
        this.data.forEach(item => {
          if (item.ReportGroupId == selectedKeys) this.dataShow.push(item);
        });
      }
    },
    //菜单权限
    qermission(type) {
      let row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      if (type == "1") {
        this.title = "菜单权限";
        this.qermissionOption.api = "GroupRole_GetRoleMenus";
      }
      this.qermissionOption.id = row.Id;
      this.visible.qermissionModal = true;
      this.treeType = type;
    },
    //功能权限
    roleQermission() {
      let row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      //this.visible.roleQermissionModal = true;
      RoleQermissionModal({ roleId: row.Id });
    },
    //门店角色权限
    companyRoleQermission() {
      let row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      CompanyRoleQermissionModal({ roleId: row.Id });
    },
    //报表权限
    roleReportQermission() {
      let row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      this.$post("GroupRole_GetReportGroupsAsync", {}).then(res => {
        let arr = [{ key: 0, title: "全部" }];
        res.Data.forEach(item => {
          arr.push({ key: item.Id, title: item.Name });
        });
        this.treeData = arr;
      });
      this.$post("GroupRole_GetReportPermissions", { RoleId: row.Id }).then(
        res => {
          this.selectedKeys = [];
          this.data = res.Data;
          this.dataShow = this.data;
        }
      );
      this.visible.roleReportQermissionModal = true;
    },
    //角色报表权限全选
    selectAll(value) {
      this.dataShow.forEach(item => {
        item.CanExport = value;
        item.CanMobile = value;
        item.CanPreview = value;
        item.CanPrint = value;
      });
    },
    //角色报表权限提交
    handleOk() {
      let row = this.$refs.dataTable.getSelected();
      this.data.forEach(item => {
        item.RoleId = row.Id;
      });
      this.$post("GroupRole_SetRoleReportDataPermission", this.data).then(
        () => {
          this.$message.info("操作成功");
          this.visible.roleReportQermissionModal = false;
        }
      );
    },
    //菜单权限提交
    onSubmit(type, treeData, checkedKeys) {
      let row = this.$refs.dataTable.getSelected();
      const json = { RoleId: row.Id, MenuCodes: checkedKeys };
      let url = "";
      if (type == "1") url = "GroupRole_SetRoleMenus";
      else if (type == "2") url = "GroupRole_SetPermissions";
      else if (type == "3") url = "GroupRole_SetRoleReportDataPermission";
      else if (type == "4") url = "GroupRole_SetRoleReportDataPermission";

      this.$post(url, json).then(() => {
        this.visible.qermissionModal = false;
        this.$message.success("操作成功！");
      });
    },
    //菜单权限关闭弹窗
    onClose() {
      this.visible.qermissionModal = false;
    }
  },
  filter: {},
  // 计算属性
  computed: {},
  watch: {}
};
</script>

<style lang="less" scoped>
.ant-layout-sider {
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  position: relative;
  background: white;
  min-width: 0;
}
</style>
